"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./checkFunctions"));
__export(require("./errors"));
var specs_1 = require("./specs");
exports.t = specs_1.t;
